import script from "./SectionFilialiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionFilialiCard.vue?vue&type=script&setup=true&lang=js"

import "./SectionFilialiCard.vue?vue&type=style&index=0&id=fb089e54&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb089e54"]])

export default __exports__